import { Instance, SnapshotOut, types } from "mobx-state-tree"

/**
 * # ExtubationInputData
 * 
 * ExtubationInputData을 설명하세요.
 */
export const ExtubationInputData = types
  .model('ExtubationInputData')
  // --------------------------------------------------------------------------
  .props({
    gender: types.optional(types.number, 0), //  남(0) / 여(1)
    age: types.optional(types.number, 0), //  입원 시 만나이
    height: types.optional(types.number, 0), //  입원 시 측정된 키
    sapsil: types.optional(types.number, 0), //  Simplified Acute Physiology Score-II, 중증도 점수 중 하나
    oasis: types.optional(types.number, 0), //  The Outcome and Assessment Information Set, 중증도 점수 중 하나
    gcs: types.optional(types.number, 0), //  Glasgow Coma Scale (글래스고 혼수 척도)
    spo2: types.optional(types.number, 0), //  Saturation of percutaneous oxygen (경피적 산소포화도)
    fio2: types.optional(types.number, 0), //  Fraction of inspired oxygen (흡입산소농도)
    mbp: types.optional(types.number, 0), //  Mean Blood Pressure (평균혈압)
    vt: types.optional(types.number, 0), //  Tidal Volume (일회호흡량)
    ve: types.optional(types.number, 0), //  Minute Ventilation (분간환기)
    hr: types.optional(types.number, 0), //  Heart Rate (심박수)
    rr: types.optional(types.number, 0), //  Respiratory Rate (호흡수)
    pimax: types.optional(types.number, 0), // Maximal Inspiratory Pressure (최대흡기압)
    copd: types.optional(types.number, 0),  //  만성 폐쇄성 폐질환 해당 입원에서 진단 유무 (1/0)
    pco2: types.optional(types.number, 0),  //  Partial pressure of arterial Carbon dioxide (동맥혈이산화탄소분압)
  })
  // --------------------------------------------------------------------------
  // MUTATEs ONLY! - 모델 상태를 변경
  // REQUESTs는 스토어 모델에 작성하세요.
  // ex) yarn gen model extubationExtubationInputData --store
  .actions((self) => ({
    /*
     * 여러 prop을 한번에 수정
     */
    setProps: (props: { [key: string]: any }) => {
      const newProps = { ...self, ...props } as IExtubationInputData;
      (Object.keys(newProps) as TExtubationInputDataKeys[]).forEach((key) => {
        self[key] = newProps[key];
      });
    },
  }));

// --------------------------------------------------------------------------
type TExtubationInputData = Instance<typeof ExtubationInputData>;
type TExtubationInputDataSnapshot = SnapshotOut<typeof ExtubationInputData>

export interface IExtubationInputData extends TExtubationInputData {}
export type TExtubationInputDataKeys = keyof TExtubationInputDataSnapshot & string;
export interface IExtubationInputDataSnapshot extends TExtubationInputDataSnapshot {}
export const createExtubationInputData = () => 
  types.optional(ExtubationInputData, {} as TExtubationInputData);
